import React , {useState} from "react"
import ElemDeleteControl from "./ElemDeleteControl"

function Component(props){
  const [controlSelected,setControlSelected]=useState(false);

  window.selectedControl_forElemDel = (controlSelectedPassed) =>{
          // setControlSelected(prev => controlSelectedPassed);
  }

  return (
    <>
    {/* {controlSelected?.id===props?.data?.id && */}
      <ElemDeleteControl {...props} />
    {/* }  */}
    </>
  )
}

export default Component;